import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2, Check, AlertCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Verify() {
  const { token } = useParams();
  const { verify } = useAuth();
  const [state, setState] = useState("loading");
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      const res = await verify(token);
      setState(res.ok ? "ok" : "error");
    })();
    // eslint-disable-next-line
  }, [token]);

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="dk-card p-8 max-w-md text-center space-y-4">
        {state === "loading" && <><Loader2 className="animate-spin mx-auto" style={{ color: "var(--sage)" }} /><p style={{ color: "var(--text-muted)" }}>Verifying your email…</p></>}
        {state === "ok" && (
          <>
            <span className="grid place-items-center w-12 h-12 rounded-full mx-auto" style={{ background: "var(--sage-tint)" }}><Check style={{ color: "var(--sage)" }} /></span>
            <h1 className="font-serif text-[26px] font-semibold">Email verified</h1>
            <p className="text-sm" style={{ color: "var(--text-muted)" }}>Your free 3-day trial has started. Let's set up your first child profile.</p>
            <button className="btn btn-primary w-full" onClick={() => nav("/app/onboarding")}>Continue</button>
          </>
        )}
        {state === "error" && (
          <>
            <span className="grid place-items-center w-12 h-12 rounded-full mx-auto" style={{ background: "#F3DEDA" }}><AlertCircle style={{ color: "var(--error)" }} /></span>
            <h1 className="font-serif text-[26px] font-semibold">This link has expired</h1>
            <button className="btn btn-primary w-full" onClick={() => nav("/auth/login")}>Go to log in</button>
          </>
        )}
      </div>
    </div>
  );
}
